var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Loading...")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),(_vm.post)?_c('div',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.post.content)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }